import React, { Component } from 'react'
import _ from 'lodash'
import {saveContact_form} from "../actions/actions"


class Contact extends Component {
	state = _.defaults({saving: false, showError: false}, this.props.contact)
	save = () => {
		const contact = this.state

		if (!contact.firstname
			|| !contact.lastname
			|| !contact.email
			|| !contact.phone
			|| !contact.message) {
			this.setState({showError: true}, () => {
				if(document.querySelectorAll(".input--error")[0]){
					document.querySelectorAll(".input--error")[0].scrollIntoView({behavior : "smooth", block : "center"})
				}
			})
		} else {
			this.setState({saving: true})
			saveContact_form(contact)
				.then(() => alert("Merci, votre message a bien été envoyé"))
				.catch(() => this.setState({saving: false}))

			// saveBillingContact(contact)
			// .then(this.props.nextStep)
			// .catch(() => this.setState({saving: false}))
		}
	}
	changeTitle = (e) => {
		this.setState({title: e.target.value})
	}
	changeFirstname = (e) => {
		this.setState({firstname: e.target.value})
	}
	changeLastname = (e) => {
		this.setState({lastname: e.target.value})
	}
	changeEmail = (e) => {
		this.setState({email: e.target.value})
	}
	changePhone = (e) => {
		this.setState({phone: e.target.value})
	}
	changeMessage = (e) => {
		this.setState({message: e.target.value})
	}
	render() {
		const { showError } = this.state
		return (
			<main id="contact" className="ptxl tiny-ptl small-ptl w100 bgc--inverse flex-item-noshrink" role="main">
				<div className="mw1140 tiny-pbl small-pbl ptxl pbxl bgc--primary">
					<h1 className="h2-like u-secondary-bold txtcenter mauto"><span className="u-small">Nous laisser un petit mot</span></h1>
				</div>
				<div className="mw1140p w80 h100 mauto medium-w60 large-w50 extra-large-w40 tiny-ptl small-ptl ptxl pbxl">
					<form className="mauto">
						<table>
							<tbody>
								<tr>
									<td className="w40"><span>Civilité</span></td>
									<td className="w60 pts pbs">
										<select className="w100" value={this.state.title} onChange={this.changeTitle}>
											<option value={10}>Mme</option>
											<option value={20}>Mr</option>
											<option value={30}>Autre</option>
										</select>
									</td>
								</tr>
								<tr>
									<td className="w40"><span>Prénom <span className="color--primary-darken">*</span></span></td>
									<td className="w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.firstname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un prénom.</span></p>
										<input className={"w100" + (showError && !this.state.firstname ? " input--error" : "")} type="text" value={this.state.firstname || ''} onChange={this.changeFirstname}/>
									</td>
								</tr>
								<tr>
									<td className="w40"><span>Nom <span className="color--primary-darken">*</span></span></td>
									<td className="w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.lastname ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un nom.</span></p>
										<input className={"w100" + (showError && !this.state.lastname ? " input--error" : "")} type="text" value={this.state.lastname || ''} onChange={this.changeLastname}/>
									</td>
								</tr>
								<tr>
									<td className="w40"><span>Email <span className="color--primary-darken">*</span></span></td>
									<td className="w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.email ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer une adresse mail.</span></p>
										<input className={"w100" + (showError && !this.state.email ? " input--error" : "")} type="email" value={this.state.email || ''} onChange={this.changeEmail}/>
									</td>
								</tr>
								<tr>
									<td className="w40"><span>Téléphone <span className="color--primary-darken">*</span></span></td>
									<td className="w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.phone ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer un numéro de téléphone.</span></p>
										<input className={"w100" + (showError && !this.state.phone ? " input--error" : "")} type='tel' value={this.state.phone || ''} onChange={this.changePhone} />
									</td>
								</tr>
								<tr>
									<td className="w40 ptm" valign="top"><span>Votre message <span className="color--primary-darken">*</span></span></td>
									<td className="w60 pts pbs">
										<p className={'color--primary-darken u-small italic' + (showError && !this.state.message ? "" : " js-hidden")}><span className="u-small">Merci d'indiquer votre message.</span></p>
										<textarea className={"w100" + (showError && !this.state.Message ? " input--error" : "")} rows="8" type='message' value={this.state.message || ''} onChange={this.changeMessage}></textarea>
									</td>
								</tr>
								
								<tr>
									<td colSpan="2"><p className="ptm u-small u-italic color--primary-darken">* Informations obligatoires</p></td>
								</tr>
							</tbody>
						</table>
						<div className='w100 pbl'>
							<button type='button' className='btn--secondary btn--big fr' disabled={this.state.saving} onClick={this.save}><span className="pll prl">Envoyer</span></button>
						</div>
					</form>
				</div>
			</main>
		)
	}
}

export default Contact


// WEBPACK FOOTER //
// ./src/components/Contact.js